import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
  searchParamsBuilder,
  searchParamsReader,
  dateArrayBuilder
} from "../../utils/utilsFunctions";
import AuthorSearch from "../UI/AuthorSearch";
import PublicationsSearch from "../UI/PublicationsSearch";
import { useSelector, useDispatch } from "react-redux";
import { fetchMenu } from "../../store/search-actions";
import FacetsContainer from "./FacetsContainer";
import TimeFacet from "../UI/TimeFacet";
const minMonth = process.env.REACT_APP_MIN_SEARCH_MONTH || 9;
const minYear = process.env.REACT_APP_MIN_SEARCH_YEAR || 2019;
const HIDE_AUTHORS_AND_PUBS =
  Boolean(process.env.REACT_APP_HIDE_AUTHORS_AND_PUBS) || false;

const Filters = () => {
  const dispatch = useDispatch();
  let [searchParams, setSearchParams] = useSearchParams();
  const isLoadingMenu = useSelector((state) => state.search.loadingMenu);
  const menuOptions = useSelector((state) => state.search.menu);

  let beforeDates = dateArrayBuilder(minMonth + 1, minYear, true);
  const afterDates = dateArrayBuilder(minMonth, minYear, false);
  if (searchParamsReader(searchParams.entries()).filters["fromDatePublished"]) {
    const fromDate = searchParamsReader(searchParams.entries()).filters[
      "fromDatePublished"
    ].split("-");
    beforeDates = dateArrayBuilder(
      Number(fromDate[1]),
      Number(fromDate[0]),
      true
    );
  }
  const filtersHandler = (id, val) => {
    const params = searchParamsReader(searchParams.entries());
    if (!params.filters[id]) {
      params.filters[id] = [
        typeof val === "number" ? String(val) : val.toLowerCase()
      ];
    } else {
      const indexOfFilter = params.filters[id].indexOf(
        typeof val === "number" ? String(val) : val.toLowerCase()
      );
      if (indexOfFilter === -1) {
        params.filters[id].push(
          typeof val === "number" ? String(val) : val.toLowerCase()
        );
      } else {
        params.filters[id].splice(indexOfFilter, 1);
        if (params.filters[id].lentgh < 1) {
          delete params.filters[id];
        }
      }
    }
    setSearchParams(searchParamsBuilder(params.queries, 0, params.filters));
  };
  const datesHandler = (id, val) => {
    const params = searchParamsReader(searchParams.entries());
    if (!params.filters[id]) {
      params.filters[id] = val;
    } else {
      /* const indexOfFilter = params.filters[id].indexOf(
        typeof val === "number" ? String(val) : val.toLowerCase()
      ); */
      if (params.filters[id] !== val) {
        params.filters[id] = val;
      } else {
        delete params.filters[id];
      }
    }
    setSearchParams(searchParamsBuilder(params.queries, 0, params.filters));
  };
  useEffect(() => {
    if (!menuOptions.length) {
      dispatch(fetchMenu());
    }
    // eslint-disable-next-line
  }, []);
  /* const facets = menuOptions.length ? */
  return (
    <div className="w-full">
      <FacetsContainer
        facetsList={menuOptions}
        isLoading={isLoadingMenu}
        selections={searchParamsReader(searchParams.entries()).filters}
        filtersHandler={filtersHandler}
      />
      {!HIDE_AUTHORS_AND_PUBS ? (
        <AuthorSearch
          label={"Authors"}
          selections={searchParamsReader(searchParams.entries()).filters}
          id={"authors"}
          filtersHandler={filtersHandler}
        />
      ) : null}
      {!HIDE_AUTHORS_AND_PUBS ? (
        <PublicationsSearch
          label={"Publications"}
          selections={searchParamsReader(searchParams.entries()).filters}
          id={"publications"}
          filtersHandler={filtersHandler}
        />
      ) : null}
      <TimeFacet
        label={"Published after"}
        facetValues={afterDates}
        selections={searchParamsReader(searchParams.entries()).filters}
        id={"fromDatePublished"}
        filtersHandler={datesHandler}
      />
      <TimeFacet
        label={"Published before"}
        facetValues={beforeDates}
        selections={searchParamsReader(searchParams.entries()).filters}
        id={"toDatePublished"}
        filtersHandler={datesHandler}
        isBefore={true}
      />
    </div>
  );
};

export default Filters;
